// TimeComponent migrated from dbaas-ui
import React from 'react'

import dayjs from 'dayjs'

interface TimeComponentProps {
  time: number
  format?: string
}

export const TimeComponent: React.FC<TimeComponentProps> = ({
  time,
  format = 'YYYY-MM-DD HH:mm:ss'
}) => {
  if (!time || time === 0) {
    return <span>-</span>
  }
  return <span>{dayjs.unix(time).format(format)}</span>
}

export const useTimeFormatter = (format: string = 'YYYY-MM-DD HH:mm:ss') => {
  return (time: number) => {
    if (!time || time === 0) {
      return '-'
    }
    return dayjs.unix(time).format(format)
  }
}

export default TimeComponent
